import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const TIMEOUT_DURATION = 5 * 60 * 1000; // 5 minutes

const AuthProvider = ({ children }) => {
    const navigate = useNavigate();

    useEffect(() => {
        let timeoutId;

        const resetTimeout = () => {
            if (timeoutId) clearTimeout(timeoutId);
            
            const token = localStorage.getItem('authToken');
            if (token) {
                timeoutId = setTimeout(handleLogout, TIMEOUT_DURATION);
            }
        };

        const handleLogout = () => {
            try {
                localStorage.removeItem('authToken');
                localStorage.removeItem('userId');
                
                // Keep estimate data
                const estimateData = localStorage.getItem('tempEstimate');
                
                // Clear other data but keep estimate
                localStorage.clear();
                if (estimateData) {
                    localStorage.setItem('tempEstimate', estimateData);
                }

                // Quiet redirect without alert
                if (window.location.pathname !== '/calculator') {
                    navigate('/');
                }
            } catch (error) {
                console.error('Logout error:', error);
            }
        };

        const events = ['mousedown', 'keydown', 'scroll', 'touchstart'];
        events.forEach(event => {
            document.addEventListener(event, resetTimeout);
        });

        resetTimeout();

        return () => {
            if (timeoutId) clearTimeout(timeoutId);
            events.forEach(event => {
                document.removeEventListener(event, resetTimeout);
            });
        };
    }, [navigate]);

    return children;
};

export default AuthProvider; 